import React from "react";

const RestaurantsNotFound = () => (
  <div className="empty-body white-bg col-sm-12 row center-sm">
    <div className="col-sm-8">
      <img src="/png/not-found.png" />
      <p>
        Sorry, we couldn{"'"}t find anything to match
        <br />
        your search..
      </p>
      <a
        href="/"
        className="btn btn-blue d-flex justify-content-center align-items-centerc"
      >
        <i className="icon icon-search" />
        <span>Try another location?</span>
      </a>
    </div>
  </div>
);

export default RestaurantsNotFound;
